import { useState, useEffect } from 'react';
import { getWindow } from '@app/shared/utils/window';
import parseUserAgent from '@appscore/device-detector';

function useIsWebView() {
  const [isWebView, setIsWebView] = useState(false);

  useEffect(() => {
    const windowObject = getWindow();
    if (!windowObject) return;
    const deviceInfo = parseUserAgent(windowObject.navigator.userAgent);
    const { deviceType } = deviceInfo;
    setIsWebView(deviceType === 'WEBVIEW');
  }, []);

  return isWebView;
}
export default useIsWebView;
